import { render, staticRenderFns } from "./DocumentRenderer.vue?vue&type=template&id=2fb6e0b4"
import script from "./DocumentRenderer.vue?vue&type=script&lang=js"
export * from "./DocumentRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports